import nls from '../../../../nls/pt-BR.json';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentProgressTo,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { ILayoutValuation } from '../../../../redux/studies.model';
import { labelFormatterMoneyAsInteger } from '../../../../../../../shared/formatters/formatters';

export const VGVResponse: React.FC = () => {
  const dispatch = useDispatch();
  const { layoutsValuationPrimaryResponse, layoutsValuationSecondaryResponse } =
    useSelector(studiesSelector);
  useEffect(() => {
    dispatch(setCurrentProgressTo(4));
  }, []);
  const primaryVGVs = layoutsValuationPrimaryResponse?.map(
    (elem) => elem.vgv?.primaryMarketVGV
  );
  const secondaryVGVs = layoutsValuationPrimaryResponse?.map(
    (elem) => elem.vgv?.secondaryMarketVGV
  );
  const VGVPrimaryTotal = primaryVGVs?.reduce(
    (accumulator, currentValue) =>
      (accumulator as number) + (currentValue as number),
    0
  );
  const VGVSum = secondaryVGVs?.reduce(
    (accumulator, currentValue) =>
      (accumulator as number) + (currentValue as number),
    0
  );
  const VGVSecondaryTotal = VGVSum && VGVSum > 0 ? VGVSum : null;
  const totalAmount = layoutsValuationPrimaryResponse?.reduce(
    (accumulator, valuation) =>
      accumulator +
      (valuation.vgv?.numberOfUnits ? valuation.vgv?.numberOfUnits : 0),
    0
  );
  return (
    <div className="vgv-response">
      {layoutsValuationPrimaryResponse?.map(
        (layout: ILayoutValuation, index) => {
          return (
            <section
              className="calculate-vgv__building-layout-calculation"
              key={index}
            >
              <h6 className="layout-number">
                {nls.studyCreationGuide.steps.step4.layoutNumber} {layout.id}
              </h6>
              <div className="calculate-vgv__building-layout-calculation__row">
                <p>{nls.studyCreationGuide.steps.step4.area}</p>
                <p style={{ fontWeight: 700 }}>{layout.area}</p>
              </div>
              <div className="calculate-vgv__building-layout-calculation__row">
                <p>{nls.studyCreationGuide.steps.step4.amount}</p>
                <p style={{ fontWeight: 700 }}>{layout.vgv?.numberOfUnits}</p>
              </div>
              <div className="calculate-vgv__building-layout-calculation__row">
                <p>{nls.studyCreationGuide.steps.step4.primaryMarketVGV}</p>
                <p style={{ fontWeight: 700 }}>
                  {labelFormatterMoneyAsInteger(
                    layout.vgv?.primaryMarketVGV ?? 0
                  )}
                </p>
              </div>
              {layout.vgv?.secondaryMarketVGV && (
                <div className="calculate-vgv__building-layout-calculation__row">
                  <p>{nls.studyCreationGuide.steps.step4.secondaryMarketVGV}</p>
                  <p style={{ fontWeight: 700 }}>
                    {labelFormatterMoneyAsInteger(
                      layout.vgv?.secondaryMarketVGV
                    )}
                  </p>
                </div>
              )}
            </section>
          );
        }
      )}
      <section className="calculate-vgv__building-layout-calculation">
        <h6 className="layout-number">
          {nls.studyCreationGuide.steps.step4.VGVTotal}
        </h6>
        <div className="calculate-vgv__building-layout-calculation__row">
          <p>{nls.studyCreationGuide.steps.step4.amount}</p>
          <p style={{ fontWeight: 700 }}>{totalAmount}</p>
        </div>
        <div className="calculate-vgv__building-layout-calculation__row">
          <p>{nls.studyCreationGuide.steps.step4.primaryVGV}</p>
          <p style={{ fontWeight: 700, color: '#793EAD' }}>
            {VGVPrimaryTotal
              ? labelFormatterMoneyAsInteger(VGVPrimaryTotal)
              : undefined}
          </p>
        </div>

        {VGVSecondaryTotal && (
          <div className="calculate-vgv__building-layout-calculation__row">
            <p>{nls.studyCreationGuide.steps.step4.secondaryVGV}</p>
            <p style={{ fontWeight: 700, color: '#793EAD' }}>
              {labelFormatterMoneyAsInteger(VGVSecondaryTotal)}
            </p>
          </div>
        )}
      </section>
    </div>
  );
};
